<h2 mat-dialog-title class="dialog-title">Liste des clients consommant ce service</h2>

<div mat-dialog-content class="dialog-content">

    <div class="table-wrapper mat-elevation-z1">
        <table mat-table [dataSource]="summary" class="default-table">

            <!-- Client -->
            <ng-container matColumnDef="clientName">
                <th mat-header-cell *matHeaderCellDef>Clients</th>
                <td mat-cell *matCellDef="let row">{{ row.clientName }}</td>
            </ng-container>

            <!-- Metrics -->
            <ng-container matColumnDef="metrics">
                <th mat-header-cell *matHeaderCellDef>Métrics</th>
                <td mat-cell *matCellDef="let row">{{ row.nbLines }} lignes</td>
            </ng-container>

            <!-- Status -->
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Statut</th>
                <td mat-cell *matCellDef="let row">{{ row.status }}</td>
            </ng-container>

            <!-- Actions -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let row">
                    <div class="action-buttons">
                        <button mat-icon-button matTooltip="Voir dans Nexus MVNO"
                            (click)="goToNexusMvno(row.organizationId)">
                            <mat-icon>home</mat-icon>
                        </button>
                        <button mat-icon-button matTooltip="Activer/Désactiver module"
                            (click)="toggleAccess(row.organizationId)">
                            <mat-icon>more_horiz</mat-icon>
                        </button>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

</div>

<div mat-dialog-actions align="end">
    <button mat-button color="primary" (click)="close()">Fermer</button>
</div>